import React from "react";
import { Row, Col, Carousel, Button } from "antd";
import "./SlideContent.css";

const sewmootSlide = [
  {
    source:
      "https://images.pexels.com/photos/809609/pexels-photo-809609.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    alt: "motor 1",
  },
  {
    source:
      "https://images.pexels.com/photos/104842/bmw-vehicle-ride-bike-104842.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    alt: "motor 2",
  },
  {
    source:
      "https://images.pexels.com/photos/2174656/pexels-photo-2174656.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    alt: "motor 3",
  },
  {
    source:
      "https://images.pexels.com/photos/1715184/pexels-photo-1715184.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    alt: "motor 4",
  },
  {
    source:
      "https://images.pexels.com/photos/159192/vespa-roller-motor-scooter-cult-159192.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    alt: "motor 5",
  },
];
class SlideContent extends React.Component {
  state = {
    dotPosition: "bottom",
  };
  render() {
    let containerWide = {
      width: "100%",
      height: "600px",
      objectFit: "cover",
    };

    let carouselDesc = {
      zIndex: "1",
      fontSize: "3vw",
      color: "#7F7CAF",
    };

    let carouselBlock = {
      padding: "20px",
      height: "600px",
    };
    return (
      <div style={{marginTop:60}}>
        <Row>
          <Col span={16}>
            <Carousel autoplay dotPosition={this.state.dotPosition}>
              {sewmootSlide.map((props, index) => (
                <a>
                  <img
                    style={containerWide}
                    alt={props.alt}
                    src={props.source}
                  ></img>
                </a>
              ))}
            </Carousel>
          </Col>
          <Col span={8} style={carouselBlock} className="carDesc">
            <div className="webText">
              <h1 style={carouselDesc}>Jelajahi lebih jauh tujuanmu.</h1>
              <p>
                Liburan akan terasa kurang maksimal jika tidak bisa dijelasi
                secara luas.
              </p>
              <p>
                <em>
                  <b>Sewmoot</b>
                </em>{" "}
                memberikan kemudahan dalam mengakses berbagai macam tempat-tempat
                indah kala liburan yang sulit dijangkau dengan kaki maupun transportasi umum
              </p>
              <Button size="large" color="black"><p className="exButton">Jelajahi Lebih Lanjut</p></Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default SlideContent;
